'use es6';

import Immutable from 'immutable';
import { AppQualityRatingsTemplate, ProfileQualityRatingsTemplate, RatingAxes } from '../constants/reviews/RatingAxes';
import { STAR_NUM_TO_STATE } from '../constants/reviews/ReviewsListQueries';
import * as ReviewTypes from '../constants/reviews/ReviewType';
const defaults = {
  count: null,
  reviewType: ReviewTypes.APP,
  axes: Immutable.Map()
};
export default class ReviewStats extends Immutable.Record(defaults) {
  static from(data) {
    return new ReviewStats(Immutable.fromJS(data));
  }

  getOverallPercentages() {
    const overall = this.axes.get(RatingAxes.OVERALL);

    if (!overall || !overall.get('distribution')) {
      return null;
    }

    const sum = overall.get('distribution').reduce((acc, val) => {
      acc += val;
      return acc;
    }, 0);
    let acc = 0; // Total percentages so far; should eventually be 100

    let difference = 0; // Ensure that overflow from rounding gets accounted for in the next calculation

    return overall.get('distribution').map((count, key) => {
      if (key === '5') {
        // Ensures that percentages add up to 100
        return 100 - acc;
      }

      const percentage = count * 100 / sum + difference;
      const roundedPercentage = Math.round(percentage);
      difference = percentage - roundedPercentage;
      acc += roundedPercentage;
      return roundedPercentage;
    });
  }

  getQualityRatings() {
    const qualityRatingsMap = this.axes.delete(RatingAxes.OVERALL).map(axisMap => axisMap.get('average'));
    const template = this.reviewType === ReviewTypes.APP ? AppQualityRatingsTemplate : ProfileQualityRatingsTemplate;
    return template.merge(qualityRatingsMap);
  }

  hasQualityRatings() {
    return this.getQualityRatings().some(val => val && val !== 'NaN');
  }

  getAxisAverage(axis) {
    return this.axes.getIn([axis, 'average']);
  }

  getValidRatingFilters() {
    return this.axes.getIn([RatingAxes.OVERALL, 'distribution']).filter(count => count).mapKeys(rating => STAR_NUM_TO_STATE.get(rating));
  }

  addNewStats(ratings) {
    let updatedAxes = this.axes;
    ratings.forEach((key, value) => {
      updatedAxes = this.updateAxis(value, updatedAxes, ratings);
    });
    return this.setIn(['axes'], updatedAxes).setIn(['count'], this.get('count') + 1);
  }

  findAverage(currentAverage, count, newRating) {
    count++;
    const weightedOld = currentAverage * ((count - 1) / count);
    const weightedNew = newRating * (1 / count);
    return weightedOld + weightedNew;
  }

  updateAxis(axisName, axes, ratings) {
    return axes.setIn([axisName, 'average'], this.findAverage(axes.getIn([axisName, 'average']), axes.getIn([axisName, 'count']), ratings.get(axisName))).setIn([axisName, 'count'], axes.getIn([axisName, 'count']) + 1).setIn([axisName, 'distribution', ratings.get(axisName).toString()], axes.getIn([axisName, 'distribution', ratings.get(axisName).toString()]) + 1);
  }

}